<template>
  <div class="paperBox">
    <div class="paperTop">
      <div class="topLeft">
        <span>考试题目：</span>共{{ skillData.length }}题（系统抽题）
      </div>
      <div class="topRight">
        倒计时：<span v-if="timeFalg">{{ formattedTime }}</span> <span v-else>{{ formatCountdown(lastTime) }}</span>
      </div>
    </div>
    <div class="paperBottom" v-if="skillData.length > 0">
      <div class="tabsBox">
        <ul class="tabsList">
          <li
            v-for="(item, index) in skillData"
            :key="index"
            :class="{ active: activeIndex === index }"
            @click="activeSkillIndex(item, index)"
          >
            试题{{ index + 1 }}
          </li>
        </ul>
        <div class="examContent">
          考试内容（{{ skillInfoIndex }}/{{ skillInfoList.length }}）
        </div>
      </div>
      <div class="descriptionBox">
        描述：<span>{{ skillInfoData.description }}</span>
        <div
          class="descriptionUrlBox"
          v-if="
            skillInfoData.descriptionFileUrl &&
            skillInfoData.descriptionFileUrl.length
          "
        >
          <ul class="imgBox">
            <template v-for="(file, i) in skillInfoData.descriptionFileUrl">
              <li v-if="isImage(file)" :key="'img-' + i">
                <img
                  :src="imgUrl + file.url"
                  :alt="'图片-' + i"
                  @click="openModal(imgUrl + file.url)"
                />
              </li>
            </template>
          </ul>
          <ul class="videoBox">
            <template v-for="(file, i) in skillInfoData.descriptionFileUrl">
              <li v-if="isVideo(file)" :key="'video-' + i">
                <video
                  controls
                  :src="imgUrl + file.url"
                  @click="handleFullscreen"
                >
                  <p>您的浏览器不支持音频播放。</p>
                </video>
              </li>
            </template>
          </ul>
          <ul class="audioBox">
            <template v-for="(file, i) in skillInfoData.descriptionFileUrl">
              <li v-if="isAudio(file)" :key="'audio-' + i">
                <audio controls :src="imgUrl + file.url">
                  <p>您的浏览器不支持音频播放。</p>
                </audio>
              </li>
            </template>
          </ul>
        </div>
        <ul class="questionBox">
          <li
            v-for="(item, index) in skillInfoData.examSkillQuestionDetails"
            :key="index"
          >
            <div class="questionName"> 问题{{ toChineseNumber(index + 1) }}：</span>{{ item.name }}</div>
            <ul class="imgBox">
              <template v-for="(file, i) in item.fileUrl">
                <li v-if="isImage(file)" :key="'img-' + i">
                  <img
                    :src="imgUrl + file.url"
                    :alt="'图片-' + i"
                    @click="openModal(imgUrl + file.url)"
                  />
                </li>
              </template>
            </ul>
            <ul class="videoBox">
              <template v-for="(file, i) in item.fileUrl">
                <li v-if="isVideo(file)" :key="'video-' + i">
                  <video
                    controls
                    :src="imgUrl + file.url"
                    @click="handleFullscreen"
                  >
                    <p>您的浏览器不支持音频播放。</p>
                  </video>
                </li>
              </template>
            </ul>
            <ul class="audioBox">
              <template v-for="(file, i) in item.fileUrl">
                <li v-if="isAudio(file)" :key="'audio-' + i">
                  <audio controls :src="imgUrl + file.url">
                    <p>您的浏览器不支持音频播放。</p>
                  </audio>
                </li>
              </template>
            </ul>
          </li>
        </ul>
      </div>
      <div class="stepBoxs"></div>
      <div class="stepBox">
          <div v-if="skillInfoIndex !== 1" @click="upperClick">上一步</div>
          <div v-if="skillInfoIndex !== skillInfoList.length" @click="belowClick">下一步</div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div v-if="isModalOpen" class="modal" @click="closeModal">
      <div class="modal-content" @click.stop>
        <img :src="currentImageUrl" alt="放大图片" />
      </div>
    </div>
    <!-- 下一步弹窗 -->
    <div v-if="nextOpen" class="nextBox" >
      <div class="next">
        <div class="nextTop">提示</div>
        <div class="nextMiddle">是否确定进入“下一步”？</div>
        <div class="nextBottom">
          <el-button type="primary" @click="nextClick">确定</el-button>
          <el-button @click="nextOpen = false">取消</el-button>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import io from "socket.io-client";
import { getScaleNum } from "@/utils/index.js";
import {
  examSkillQuestion,
  getSkillInfo,
  getIp,
  getDeviceInfo,
} from "@/api/paper/paper";
export default {
  data() {
    return {
      examSkillIds: "",
      token: "",
      remainingTime: 0, // 初始时间，单位为秒（1小时29分59秒）
      remainingTimeInSeconds: 0, // 转换后的秒数，用于倒计时
      timer: null, // 定时器引用
      skillData: [],
      activeIndex: 0,
      skillInfoList: [],
      skillInfoIndex: 1,
      skillInfoData: {},
      timeFalg: true,
      ipData: "",
      isModalOpen: false, // 控制弹窗显示
      currentImageUrl: "", // 当前放大图片的 URL
      ipData: "",
      socket: null, // WebSocket 实例
      socketConnected: false, // WebSocket 连接状态
      reconnectAttempts: 0, // 重连次数
      maxReconnectAttempts: 1000, // 最大重连次数
      reconnectDelay: 3000, // 重连间隔时间（毫秒）
      roomIdInfo: "",
      lastTime: "",
      countdownInterval: null,
      nextOpen: false,
    };
  },
  created() {
    const codeAddress = this.$route.query.codeAddress;
    this.ipData = codeAddress;
    // console.log('codeAddress',codeAddress)
    // this.ipData = window.location.hostname; // 获取当前页面的主机名
    this.checkRouteParams();
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 销毁组件时清除定时器
    }
  },
  computed: {
    // 根据秒数计算并格式化时间为 HH:MM:SS
    formattedTime() {
      const totalSeconds = this.remainingTime; // 使用秒数
      const hours = Math.floor(totalSeconds / 3600); // 计算小时数
      const minutes = Math.floor((totalSeconds % 3600) / 60); // 计算分钟数
      const seconds = totalSeconds % 60; // 计算秒数
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(seconds).padStart(2, "0")}`;
    },
  },
  mounted() {
    // this.startCountdown();
    // 检查路由是否有传参
    if (this.$route.query.examSkillIds) {
      this.timeFalg = true;
      this.startCountdown();
    } else {
      this.timeFalg = false;
    }
  },
  methods: {
    // 格式化倒计时为 mm:ss
    formatCountdown(seconds) {
      const hours = Math.floor(seconds / 3600); // 小时数
      const minutes = Math.floor((seconds % 3600) / 60); // 分钟数
      const secs = seconds % 60; // 秒数

      // 返回格式化的字符串，使用 padStart 保证每个部分都有两位数
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
    },

    // 启动倒计时
    startCountdowns() {
      if (this.lastTime <= 0) {
        return; // 如果时间已经为0，直接返回
      }

      this.countdownInterval = setInterval(() => {
        this.lastTime--; // 每秒减少 1 秒
        if (this.lastTime <= 0) {
          clearInterval(this.countdownInterval); // 倒计时结束，清除定时器
          this.lastTime = 0; // 防止显示负数
        }
      }, 1000);
    },
    checkRouteParams() {
      // 检查是否通过路由传参
      if (this.$route.query.examSkillIds) {
        this.timeFalg = true;
        const examSkillIds = this.$route.query.examSkillIds; // 获取 examSkillIds 字符串
        const examSkillIdsArray = examSkillIds.split(","); // 转换为数字数组
        this.examSkillIds = examSkillIdsArray;
        this.remainingTime = Number(this.$route.query.time);
        // this.$route.query.time
        this.token = this.$route.query.token;
        let scaleNum = getScaleNum();
        document.documentElement.style.setProperty("--scale", scaleNum);
        window.addEventListener("resize", () => {
          let scaleNum = getScaleNum();
          document.documentElement.style.setProperty("--scale", scaleNum);
        });
        this.examSkillQuestionList();
        this.startCountdown();
      } else {
        this.timeFalg = false;
        // this.getIpData();

        this.connectSocket();
        this.getDeviceInfoList();
        this.getSkillInfoList();
      }
      console.log("timeFalg", this.timeFalg);
    },
    startCountdown() {
      // 检查是否有未清除的计时器
      if (this.timer) {
        clearInterval(this.timer); // 清除之前的计时器
        this.timer = null;
      }
      // 启动定时器，每秒递减
      this.timer = setInterval(() => {
        if (this.remainingTime > 0) {
          this.remainingTime--; // 按秒递减
        } else {
          clearInterval(this.timer); // 清除定时器
          this.timer = null;
          this.countdownComplete(); // 倒计时完成回调
        }
      }, 1000);
    },
    countdownComplete() {
      console.log("倒计时结束！");
      // 在这里处理倒计时结束逻辑，例如提示或跳转
    },
    async examSkillQuestionList() {
      const setList = {
        examSkillIds: this.examSkillIds.join(","),
        token: this.token,
      };
      const { data } = await examSkillQuestion(setList);
      this.skillData = data;
      // 处理数据
      this.skillData.forEach((item) => {
        item.examSkillQuestionParts.forEach((value) => {
          if (value.descriptionFileUrl) {
            value.descriptionFileUrl = String(value.descriptionFileUrl)
              .split(",")
              .map((url) => ({ url }));
          }
          if (value.examSkillQuestionDetails) {
            value.examSkillQuestionDetails.forEach((v) => {
              if (v.fileUrl) {
                v.fileUrl = v.fileUrl.split(",").map((url) => ({ url }));
              }
            });
          }
        });
      });
      this.getSkillInfo();
    },
    async getIpData() {
      const { data } = await getIp();
      // "192.168.110.30"
      this.ipData = data;
    },
    async getDeviceInfoList() {
      const { data } = await getDeviceInfo(this.ipData);
      this.roomIdInfo = data.roomId;
    },
    // 初始化 WebSocket
    connectSocket() {
      console.log("尝试连接 WebSocket...");
      // 动态获取当前页面的协议和主机名
      // const protocol = window.location.protocol === "https:" ? "wss" : "ws"; // 根据页面协议选择 ws 或 wss
      const protocol = "ws";
      const hostname = window.location.hostname; // 获取当前页面的主机名
      const socketPort = 7777; // 强制使用 WebSocket 的端口 7777
      // 构建 WebSocket URL
      const socketUrl = `${protocol}://${hostname}:${socketPort}/`;
      console.log("socketUrl", socketUrl);
      // ws://192.168.3.200:7777
      // socketUrl
      this.socket = io(socketUrl, {
        query: {
          userId: this.ipData,
        },
        transports: ["websocket", "polling"],
        timeout: 5000,
      });

      // 监听连接事件
      this.socket.on("connect", () => {
        console.log("WebSocket 连接成功");
        this.socketConnected = true;
        this.reconnectAttempts = 0; // 重置重连次数
      });

      // 监听连接错误事件
      this.socket.on("connect_error", (error) => {
        console.error("WebSocket 连接失败", error);
        this.socketConnected = false;
        this.tryReconnect(); // 尝试重连
      });

      // 监听断开事件
      this.socket.on("disconnect", (reason) => {
        console.warn("WebSocket 已断开", reason);
        this.socketConnected = false;
        if (reason !== "io client disconnect") {
          this.tryReconnect(); // 尝试重连
        }
      });

      // 考生在指定房间开始考试
      this.socket.on("start_004", (data) => {
        if (data[0].roomId == this.roomIdInfo) {
          setTimeout(() => {
            this.getSkillInfoList();
          }, 3000); // 3000 毫秒 = 3 秒
        }
      });
    },
    // 尝试重连 WebSocket
    tryReconnect() {
      // if (this.reconnectAttempts < this.maxReconnectAttempts) {
      // this.reconnectAttempts++;
      // console.log(`尝试第 ${this.reconnectAttempts} 次重连 WebSocket...`);
      setTimeout(() => {
        this.connectSocket();
      }, this.reconnectDelay);
      // }
      //  else {
      //   console.error("已达到最大重连次数，停止重连");
      // }
    },
    async getSkillInfoList() {
      const setList = {
        codeAddress: this.ipData,
      };
      const { data } = await getSkillInfo(setList);
      this.lastTime = data.lastTime;
      // 初始化时启动倒计时
      this.startCountdowns();
      this.skillData = data.examSkillQuestionDTOs;
      // 处理数据
      this.skillData.forEach((item) => {
        item.examSkillQuestionParts.forEach((value) => {
          if (value.descriptionFileUrl) {
            value.descriptionFileUrl = String(value.descriptionFileUrl)
              .split(",")
              .map((url) => ({ url }));
          }
          if (value.examSkillQuestionDetails) {
            value.examSkillQuestionDetails.forEach((v) => {
              if (v.fileUrl) {
                v.fileUrl = v.fileUrl.split(",").map((url) => ({ url }));
              }
            });
          }
        });
      });
      this.getSkillInfo();
    },

    getSkillInfo() {
      this.skillInfoList =
        this.skillData[this.activeIndex].examSkillQuestionParts;
      this.skillInfoData = this.skillInfoList[this.skillInfoIndex - 1];
    },

    activeSkillIndex(item, index) {
      this.activeIndex = index;
      this.skillInfoIndex = 1;
      this.getSkillInfo();
    },

    upperClick() {
      this.skillInfoIndex = this.skillInfoIndex - 1;
      this.getSkillInfo();
    },

    belowClick() {
      this.nextOpen = true;
    },

    nextClick() {
      this.nextOpen = false;
      this.skillInfoIndex = this.skillInfoIndex + 1;
      this.getSkillInfo();
    },

    // 将阿拉伯数字转为中文数字
    toChineseNumber(num) {
      const chineseNumbers = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
      ];

      if (num <= 9) {
        return chineseNumbers[num - 1];
      } else if (num === 10) {
        return "十";
      } else if (num < 20) {
        return "十" + chineseNumbers[num - 11]; // 11 到 19
      } else if (num === 20) {
        return "二十";
      } else if (num < 30) {
        return "二十" + chineseNumbers[num - 21]; // 21 到 29
      } else if (num === 30) {
        return "三十";
      } else if (num < 40) {
        return "三十" + chineseNumbers[num - 31]; // 31 到 39
      } else if (num === 40) {
        return "四十";
      } else if (num < 50) {
        return "四十" + chineseNumbers[num - 41]; // 41 到 49
      } else if (num === 50) {
        return "五十";
      } else if (num < 60) {
        return "五十" + chineseNumbers[num - 51]; // 51 到 59
      } else if (num === 60) {
        return "六十";
      } else if (num < 70) {
        return "六十" + chineseNumbers[num - 61]; // 61 到 69
      } else if (num === 70) {
        return "七十";
      } else if (num < 80) {
        return "七十" + chineseNumbers[num - 71]; // 71 到 79
      } else if (num === 80) {
        return "八十";
      } else if (num < 90) {
        return "八十" + chineseNumbers[num - 81]; // 81 到 89
      } else if (num === 90) {
        return "九十";
      } else if (num < 100) {
        return "九十" + chineseNumbers[num - 91]; // 91 到 99
      } else {
        return num.toString(); // 如果超过99，直接返回数字
      }
    },
    // 判断文件是否是图片
    isImage(file) {
      return (
        file.url &&
        (file.url.endsWith(".jpg") ||
          file.url.endsWith(".jpeg") ||
          file.url.endsWith(".png") ||
          file.url.endsWith(".gif"))
      );
    },

    // 判断文件是否是视频
    isVideo(file) {
      return file.url && file.url.endsWith(".mp4");
    },

    // 判断文件是否是音频
    isAudio(file) {
      return (
        file.url && (file.url.endsWith(".mp3") || file.url.endsWith(".wav"))
      );
    },
    // 视频点击时请求全屏
    handleFullscreen(event) {
      const videoElement = event.target;
      if (videoElement.requestFullscreen) {
        videoElement.requestFullscreen(); // Chrome, Firefox, Opera, Safari
      } else if (videoElement.mozRequestFullScreen) {
        videoElement.mozRequestFullScreen(); // Firefox
      } else if (videoElement.webkitRequestFullscreen) {
        videoElement.webkitRequestFullscreen(); // Chrome, Safari
      } else if (videoElement.msRequestFullscreen) {
        videoElement.msRequestFullscreen(); // IE/Edge
      }
    },
    // 打开弹窗，显示大图
    openModal(imageUrl) {
      this.currentImageUrl = imageUrl;
      this.isModalOpen = true;
    },
    // 关闭弹窗
    closeModal() {
      this.isModalOpen = false;
      this.currentImageUrl = ""; // 清空当前图片 URL
    },
  },
};
</script>

<style lang="scss" scoped>
:root {
  --scale: 1;
}
$scale: var(--scale, 1);
.paperBox {
  width: 100%;
  min-height: 100vh; /* 保证最小高度为屏幕高度 */
  background: #f8fbfd;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  background: #f8fbfd;

  .paperTop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: calc(#{$scale} * 60px);
    padding-right: calc(#{$scale} * 60px);
    height: calc(#{$scale} * 90px);
    background: linear-gradient(180deg, #ffffff 0%, #afc3d0 100%);
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: calc(#{$scale} * 32px);
    color: #0b476c;
    font-style: normal;
    z-index: 999;
    span {
      font-weight: 600;
      font-size: calc(#{$scale} * 32px);
    }
  }
  .paperBottom {
    padding-top: calc(#{$scale} * 114px);
    padding-left: calc(#{$scale} * 60px);
    padding-right: calc(#{$scale} * 60px);
    // padding-bottom: ;
    .tabsBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .tabsList {
        display: flex;
        li {
          margin-right: calc(#{$scale} * 20px);
          width: calc(#{$scale} * 150px);
          height: calc(#{$scale} * 62px);
          line-height: calc(#{$scale} * 62px);
          text-align: center;
          background: linear-gradient(180deg, #f1f7fd 0%, #afc3d0 100%);
          border-radius: calc(#{$scale} * 31px);
          list-style: none;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: calc(#{$scale} * 28px);
          color: #0b476c;
          font-style: normal;
          cursor: pointer; /* 小手 */
        }
        .active {
          background: linear-gradient(180deg, #659ebe 0%, #2c678c 100%);
          color: #ffffff;
        }
      }
      .examContent {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #0b476c;
        line-height: 32px;
        text-align: left;
        font-style: normal;
      }
    }
    .descriptionBox {
      margin-top: calc(#{$scale} * 34px);
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: calc(#{$scale} * 30px);
      color: #131d32;
      text-align: left;
      font-style: normal;
      span {
        font-weight: 500;
        font-size: calc(#{$scale} * 26px);
      }
      .descriptionUrlBox {
        margin-top: calc(#{$scale} * 24px);
      }
    }
    .questionBox {
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: calc(#{$scale} * 30px);
      color: #131d32;
      text-align: left;
      font-style: normal;
      li {
        list-style: none;
        margin-bottom: calc(#{$scale} * 32px);
        .questionName {
          margin-bottom: calc(#{$scale} * 40px);
        }
      }
    }
    .stepBoxs {
      width: 100%;
      height: calc(#{$scale} * 92px);
    }
    .stepBox {
      position: fixed;
      bottom: calc(#{$scale} * 20px);
      display: flex;
      justify-content: center;
      width: 100%;
      height: calc(#{$scale} * 72px);
      div {
        margin-left: calc(#{$scale} * 20px);
        width: calc(#{$scale} * 174px);
        height: calc(#{$scale} * 72px);
        background: linear-gradient(180deg, #659ebe 0%, #2c678c 100%);
        border-radius: calc(#{$scale} * 36px);
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: calc(#{$scale} * 32px);
        color: #ffffff;
        line-height: calc(#{$scale} * 72px);
        text-align: center;
        font-style: normal;
        cursor: pointer; /* 小手 */
      }
    }
    .imgBox {
      display: flex;
      flex-wrap: wrap;
      li {
        list-style: none; /* 去掉默认的列表样式 */
        background-color: salmon; /* 背景色示例 */
        margin-right: calc(#{$scale} * 20px); /* 设置项之间的右边距 */
        margin-bottom: calc(#{$scale} * 24px); /* 设置项之间的下边距 */
        width: calc(
          25% - calc(#{$scale} * 20px)
        ); /* 每行 4 个元素，减去右边距的部分 */
        position: relative;
        img {
          position: absolute; /* 让图片覆盖整个容器 */
          top: 0;
          left: 0;
          width: 100%; /* 图片宽度填充父元素 */
          height: 100%; /* 图片高度填充父元素 */
          object-fit: cover; /* 填充整个容器并裁切图片 */
          // object-fit: fill; /* 拉伸填充容器 */
        }
      }
      li.content {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
      li::before {
        content: "";
        display: block;
        padding-top: 100%;
      }
      // display: flex; /* 启用 Flexbox 布局 */
      // flex-wrap: wrap; /* 自动换行 */
      // gap: calc(#{$scale} * 20px); /* 设置图片项之间的间距 */
      // padding: 0; /* 去掉容器的默认内边距 */
      // margin: 0; /* 去掉容器的默认外边距 */
      // li {
      //   margin-bottom: calc(#{$scale} * 24px);
      //   width: calc(
      //     #{$scale} * calc(25% - 80px)
      //   ); /* 每个图片宽度为 25% 减去右边距的一部分 */
      //   // aspect-ratio: 1; /* 宽高比为 1:1，使其正方形 */
      //   height: calc(#{$scale} * 360px);
      //   list-style: none; /* 去掉列表项的默认样式 */
      //   position: relative; /* 为了让 img 覆盖整个 li */

      //   img {
      //     position: absolute; /* 让图片覆盖整个容器 */
      //     top: 0;
      //     left: 0;
      //     width: 100%; /* 图片宽度填充父元素 */
      //     height: 100%; /* 图片高度填充父元素 */
      //     object-fit: cover; /* 填充整个容器并裁切图片 */
      //     // object-fit: fill; /* 拉伸填充容器 */
      //   }
      // }
    }
    .videoBox {
      padding: 0; /* 去掉容器的默认内边距 */
      margin: 0; /* 去掉容器的默认外边距 */
      display: flex; /* 启用 Flexbox 布局 */
      flex-wrap: wrap; /* 如果不够空间自动换行 */
      gap: calc(#{$scale} * 20px); /* 设置间距，控制视频之间的间距 */

      li {
        margin-bottom: calc(#{$scale} * 24px);
        width: calc(#{$scale} * 593px); /* 视频宽度填充父元素 */
        height: calc(#{$scale} * 360px); /* 视频高度填充父元素 */
        list-style: none; /* 去除默认的列表样式 */

        video {
          top: 0;
          left: 0;
          width: calc(#{$scale} * 593px); /* 视频宽度填充父元素 */
          height: calc(#{$scale} * 360px); /* 视频高度填充父元素 */
          object-fit: cover; /* 填充整个容器并裁切视频 */
        }
      }
    }
    .audioBox {
      padding: 0; /* 去掉容器的默认内边距 */
      margin: 0; /* 去掉容器的默认外边距 */
      li {
        margin-bottom: calc(#{$scale} * 24px);
        position: relative; /* 为了让 img 覆盖整个 li */
        // width: 300px; /* 让 audio 播放器宽度填充父元素 */
        // height: 54px; /* 让 audio 播放器高度填充父元素 */
        width: calc(#{$scale} * 300px); /* 视频宽度填充父元素 */
        height: calc(#{$scale} * 54px); /* 视频高度填充父元素 */
        list-style: none; /* 去掉列表项的默认样式 */
        /* 设置 li 的最小宽高 */
        min-width: 300px; /* 设置最小宽度，避免缩放过小 */
        min-height: 54px; /* 设置最小高度，避免缩放过小 */
        audio {
          width: 100% !important; /* 让 audio 播放器宽度填充父元素 */
          height: 100% !important; /* 让 audio 播放器高度填充父元素 */
        }
      }
    }
  }
  /* 弹窗样式 */
  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    position: relative;
    max-width: 80%;
    max-height: 80%;
  }

  .modal-content img {
    width: 100%;
    height: auto;
  }

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    color: #fff;
    font-size: 36px;
    font-weight: bold;
    cursor: pointer;
  }

  .close:hover {
    color: #f44336; /* 鼠标悬停时改变颜色 */
  }
  .nextBox {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    .next {
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      margin: auto; /* Automatically calculates margins to center */
      width: calc(#{$scale} * 500px);
      height: calc(#{$scale} * 300px);
      background-color: #fff;
      border-radius: calc(#{$scale} * 5px);
      .nextTop {
        margin-top: calc(#{$scale} * 30px);
        width: 100%;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
      }
      .nextMiddle {
        margin-top: calc(#{$scale} * 60px);
        width: 100%;
        text-align: center;
        font-size: 18px;
        font-weight: 500;
      }
      .nextBottom {
        margin-top: calc(#{$scale} * 60px);
        width: 100%;
        text-align: center;
      }
    }
  }
}
</style>
